export default function stripTimeZone(date: string) {
  return date.replace(/(\d+-\d+-\d+T\d+:\d+:\d+).+/, '$1')
}
